module.exports = __webpack_public_path__ + "img/aifitLogo.503970b4.png";